import { apiGet, apiPut, apiPost, apiDelete } from "@redriver/cinnamon";
import { validate as isValidGuid } from "uuid";

const NAMESPACE = "SETTINGS/RETURN_ON_INVESTMENTS";

export const ActionTypes = {
  GetReturnOnInvestments: `${NAMESPACE}/GET_RETURN_ON_INVESTMENTS`,
  GetReturnOnInvestmentForEdit: `${NAMESPACE}/GET_RETURN_ON_INVESTMENT_EDIT`,
  AddReturnOnInvestment: `${NAMESPACE}/ADD_RETURN_ON_INVESTMENT`,
  UpdateReturnOnInvestment: `${NAMESPACE}/UPDATE_RETURN_ON_INVESTMENT`,
  RemoveReturnOnInvestmentById: `${NAMESPACE}/REMOVE_RETURN_ON_INVESTMENT_BY_ID`,
  GetReturnOnInvestmentLabel: `${NAMESPACE}/GET_RETURN_ON_INVESTMENT_LABEL`,
  UpdateReturnOnInvestmentLabel: `${NAMESPACE}/UPDATE_RETURN_ON_INVESTMENT_LABEL`,
};

export const getReturnOnInvestments = (
  { filters, pagination },
  { dealerOfficeId },
) => {
  const { pageSize, pageNumber } = pagination;
  const { search, sortName, sortDirection } = filters;

  return apiGet(ActionTypes.GetReturnOnInvestments, `return-on-investments`, {
    dealerOfficeId,
    pageSize,
    pageNumber,
    search,
    sortName,
    sortDirection,
  });
};

export const getReturnOnInvestmentForEdit = ({ id }) =>
  apiGet(
    ActionTypes.GetReturnOnInvestmentForEdit,
    `return-on-investments/${id}`,
  );

export const addReturnOnInvestment = (data, { dealerOfficeId }) =>
  apiPost(ActionTypes.AddReturnOnInvestment, `return-on-investments`, {
    ...data,
    dealerOfficeId,
  });

export const editReturnOnInvestment = (data, { id }) =>
  apiPut(ActionTypes.UpdateReturnOnInvestment, `return-on-investments/${id}`, {
    ...data,
    meteredServices: (data.meteredServices ?? []).map((ms) => ({
      ...ms,
      id: isValidGuid(ms.id) ? ms.id : undefined, // Backend expects null or a Guid, not the timestamp the UI uses for new items
    })),
  });

export const removeReturnOnInvestment = (id) =>
  apiDelete(
    ActionTypes.RemoveReturnOnInvestmentById,
    `return-on-investments/${id}`,
  );

export const getReturnOnInvestmentLabel = ({ dealerOfficeId }) =>
  apiGet(
    ActionTypes.GetReturnOnInvestmentLabel,
    `return-on-investments-label`,
    {
      dealerOfficeId,
    },
  );

export const updateReturnOnInvestmentLabel = (data, { dealerOfficeId }) =>
  apiPut(
    ActionTypes.UpdateReturnOnInvestmentLabel,
    `return-on-investments-label`,
    {
      ...data,
      dealerOfficeId,
    },
  );
